import React from "react";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { Button, Grid, SubmitButton, Dialog, makeStyles } from "../../../../";
import { Debug } from "../../../../Molecules/Forms/Debug";
var passwordSchema = Yup.object().shape({
  password: Yup.string().required("Campo obligatorio"),
  id: Yup.string().required("Campo obligatorio")
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    w50: {
      width: "50%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    }
  };
});

var DialogCertificatePassword = function DialogCertificatePassword(props) {
  // console.log("DialogCertificatePassword props", props);
  var checkPassword = props.checkPassword,
      id = props.id,
      onClose = props.onClose,
      open = props.open;
  var initialValues = {
    id: id
  };
  var classes = useStyles();
  var title = "Introduce tu contraseña";
  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    title: title,
    open: open,
    onClose: onClose,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: passwordSchema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;
      checkPassword(values);
      resetForm = {
        id: "",
        password: ""
      };
      onClose();
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "check-password",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, /*#__PURE__*/React.createElement(Field, {
        "data-cy": "password",
        name: "password",
        fullWidth: true,
        key: "password",
        label: "Contrase\xF1a",
        component: TextField,
        type: "password",
        variant: "outlined"
      })), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: onClose
      }, "Cancelar"), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, "Descargar"))));
    }
  })))];
};

export { DialogCertificatePassword };